import { FC, useMemo } from 'react'
import { ChartContainer } from 'src/components/chart/container'
import { Colors } from 'src/components/theme'

const SERIES = [
  {
    name: 'Growth Percentage',
    animation: false,
    data: [
      [2014, 0],
      [2015, 25],
      [2016, -10],
      [2017, 45],
      [2018, 70],
      [2019, 100],
      [2020, 75],
      [2021, 10],
      [2022, -5],
      [2023, -10],
      [2024, 20],
    ],
  },
]

export const PropertyValuationOvertimeChart: FC = () => {
  const options = useMemo(() => {
    const options = {
      chart: {
        type: 'line',
        animation: false,
      },
      title: undefined,
      xAxis: {
        crosshair: true,
        lineWidth: 0,
        tickWidth: 0,
        labels: {
          style: {
            fontSize: '14px',
            fontWeight: 500,
          },
        },
      },
      yAxis: {
        crosshair: false,
        tickAmount: 5,
        startOnTick: false,
        title: {
          text: 'Growth Percentage',
          style: {
            fontSize: '14px',
            fontWeight: 500,
          },
        },
        labels: {
          style: {
            fontSize: '14px',
            fontWeight: 500,
          },
        },
        min: -100,
        max: 100,
        plotLines: [
          {
            value: 0,
            width: 1,
            color: Colors.neutral500,
            zIndex: 1,
          },
        ],
      },
      plotOptions: {
        line: {
          color: Colors.primaryRed600,
        },
      },
      legend: { enabled: false },
      series: SERIES,
    }

    return options as any
  }, [])

  return <ChartContainer options={options} />
}
